<template>
  <div class="symabio-members" data-model-id="3141:822">
    <div class="background-image-wrapper">
      <div class="background-image">
          <img
            class="freepik-expand"
            alt="Freepik expand"
            src="/img/freepik-green-long-grass.png"
          />
        <div class="background-overlay" /> 
        <div class="background" />
      </div>
    </div>
    <div class="main-container">
      <header>
        <div class='burger-wrapper' v-show="tmode || mmode">
          <button class="burger-button">
            <div class='line1'></div>
            <div class='line2'></div>
          </button>
        </div>
        <div class="navbar" v-show="wsmode">
          <router-link to="/" class="navbar-item">Accueil</router-link>
          <router-link to="/about" class="navbar-item">Symabio</router-link>
          <router-link to="/pagemembres" class="navbar-item">Membres</router-link>
          <router-link to="/reglement" class="navbar-item">Réglementations</router-link>
        </div>
        <router-link to="/" class="logo">
          <img
          class="logo-symabio"
          alt="Logo symabio"
          src="/img/logo-symabio.png"
          />
        </router-link>
      </header>
      <div class="content-flex">
        <div class="subtitle">Les membres de Symabio</div>
       
        
      </div>
      <SimpleCategories />
      <div class="divider" />
      <PileMembresCards />
      <div class="divider" />

    </div>
  </div>
</template>

<script>
import SimpleCategories from "./SymabioMembres/sections/SimpleCategories.vue";
import PileMembresCards from "./SymabioMembres/sections/PileMembresCards.vue";

export default {
  name: "SymabioMembres",
  components: {
    SimpleCategories,
    PileMembresCards,
  },
  props:{
    wsmode:{
        type: Boolean,
        default: false
      },
    tmode:{
      type: Boolean,
      default: false
    },
    mmode:{
      type: Boolean,
      default: false
    }
  }
};
</script>

<style>
.symabio-members {
  height: 100vh;
  margin: 0;
  padding: 0;
  position: absolute;
}
.symabio-members header{
  /* background: linear-gradient(to bottom,#e6e3b5,#e6e3b5) ; */
  background: linear-gradient(to right, #c5c69c, #cdc99c, #ceca9c) ;
  /* background: #ceca9c ; */
  position: fixed;
  height: 120px;
  top:0;
  display: flex;
  flex: 1;
  width: 100%;
  z-index: 99;

}
.symabio-members .burger-wrapper {
  z-index: 1000;
  position: absolute;
  right: 2vw;
  top: 56px;
}
.symabio-members .burger-button {
  height: max-content;
  display: flex;
  flex-direction: column;
  align-items: flex-end ;
  justify-content: center;
  gap:6px;
  cursor: pointer;
  background: none;
  border: none;
}
.symabio-members .line1,.symabio-members .line2{
  border-radius: 2px;
  background: #3b723e;
  height: 3.1px;
  transition: width 0.5s ease-in-out, transform 0.5s ease-in-out;
}
.symabio-members .line1{
  width: 40px;
}
.symabio-members .line2{
  width: 30px;
}
/* header logo navbar  */
.symabio-members .navbar {
  align-items: center;
  display: inline-flex;
  gap: 4vw;
  right: 3vw;
  position: fixed;
  top: 52px;
}

.symabio-members .navbar-item {
  color: #000000;
  font-family: "Mona-Sans-Light", Helvetica;
  font-size: 16px;
  font-weight: 300;
  letter-spacing: 0;
  line-height: 24px;
  /* margin-top: -1.00px; */
  /* position: relative; */
  white-space: nowrap;
  width: fit-content;
}

.symabio-members .logo {
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  gap: 10px;
  left: 7vw;
  padding: 10px;
  position: fixed;
  top: 24px;
}

.symabio-members .logo-symabio {
  align-self: stretch;
  height: 64px;
  object-fit: cover;
  position: relative;
  width: 100%;
}

.symabio-members .background-image-wrapper {
  position: fixed;
  background: #e6e3b5;
  height: 100vh;
  left: 0;
  top: 0;
  width: 100vw;
  z-index: -999;
}

.symabio-members .background-image {
  height: 100%;
}
.symabio-members .freepik-expand {
  opacity: 0.24;
  object-fit: cover;
  position: fixed;
  top: 0;
  width: -webkit-fill-available;
  animation: parallax 3s ease-in;
}

@keyframes parallax {
  0%{
    scale: 1.5;
  }
  100%{
    scale: 1;
  }
}

.symabio-members .background-overlay {
  background: #01010114;
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
}

.symabio-members .background {
  mix-blend-mode: multiply;
  background: #e6e3b57d;
  position: fixed;
  top: 0;
  width: 100%;
  height: 100%;
}

.symabio-members .main-container{
  /* background-color: white; */
  padding-top: 32px;
  height: 100%;
  width: 100vw;
  overflow-y: auto;
  scrollbar-width: 0;
  scrollbar-color: rgba(76, 175, 79, 0.01) transparent;
  /* overflow-x: hidden; */
  scrollbar-width: none;
}
/* Chrome, Edge, Safari */
.symabio-members .overlap::-webkit-scrollbar {
  width: 8px;
}

.symabio-members .overlap::-webkit-scrollbar-track {
  background: transparent;
}

.symabio-members .overlap::-webkit-scrollbar-thumb {
  background: #4caf50;
  border-radius: 4px;
}
.symabio-members .content-flex {
  display: flex;
  justify-content: space-between;
  width: -webkit-fill-available;
  margin: 20vh 8vw 24px 8vw;
}
.symabio-members .subtitle {
  color: #3b723e;
  font-family: "Mona-Sans-Light", Helvetica;
  font-size: 4vw;
  font-weight: 300;
  letter-spacing: 0;
  line-height: normal;
  white-space: nowrap;
}

.symabio-members .searchbar {
  align-items: center;
  display: flex;
  gap: 6px;
  width: 36%;
  align-items: center;
  display: flex;
  gap:12px;
}

.symabio-members .input-container {
  width: -webkit-fill-available;
}
.symabio-members .input-container input {
  border: none;
  background: #fffde5cc;
  border-radius: 16px;
  width: -webkit-fill-available;
  height: 64px;
  font-size: 20px;
  font-weight: 300;
  color: #3b723e;
  text-indent: 24px;
  outline-color:  #72703b ;
  outline-width: 2px;
}
.symabio-members .input-container input::placeholder{
  color: #3b723e;
  font-weight: 200;
}

.symabio-members .search-button {
  background: #3b723e;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 62px;
  width: 72px;
}

.symabio-members .mingcute-search-line {
  height: 24px;
  position: relative;
  width: 24px;
}
.symabio-members .divider{
  height: 4vh;
}
@media (max-height: 1200px){
  .symabio-members .freepik-expand {
    height: -webkit-fill-available;
    animation: parallax 2s ease-in;
  }
}
@media (max-width: 773px){
  .symabio-members .content-flex {
    margin: 132px 6vw 24px 6vw;
    display: grid;
    gap: 8px;
    grid-template-columns: 1fr;
  }
  .symabio-members .subtitle {
    font-size: 32px;
    width: -webkit-fill-available;
  }
  .symabio-members .searchbar {
    width: -webkit-fill-available;
  }
}
</style>